
export const easterCamp = {
  title: "Acampamento de Páscoa",
  subtitle: "Uma experiência única de aprendizagem e diversão em contato com a natureza",
  gallery: {
    title: "Galeria",
    caption: "Momentos dos nossos acampamentos de Páscoa",
    images: [
      { src: "/lovable-uploads/patio-futbol-pradera.png", alt: "Crianças explorando a natureza" },
      { src: "/lovable-uploads/patio-carpinteria-cana.png", alt: "Atividades ao ar livre" },
      { src: "/lovable-uploads/huerta-charco-barro.png", alt: "Materiais Montessori" }
    ]
  },
  description: {
    title: "Visão Geral do Acampamento",
    content1: "Nosso acampamento de Páscoa oferece uma variedade de atividades, incluindo oficinas de culinária, experimentos científicos, brincadeiras na natureza e arte criativa com Voadoras. Vamos desenvolver atividades detalhadas assim que soubermos o número de crianças participantes, mas enviaremos exemplos de atividades e oficinas nos próximos dias.",
    content2: "Nossos professores têm muitas ideias de culinária e atividades criativas planejadas. Usaremos materiais disponíveis em Gándara, criando um ambiente que incentiva a exploração, a criatividade e a diversão!"
  },
  activities: {
    title: "Atividades e Oficinas",
    list: [
      "Oficinas de culinária adaptadas para crianças",
      "Experimentos científicos divertidos e educativos",
      "Brincadeiras na natureza e exploração ao ar livre",
      "Arte criativa com Voadoras",
      "Projetos de arte em argila com texturas de objetos cotidianos, elementos naturais e materiais reciclados",
      "Projetos de arte inspirados na artista Louise Nevelson, criando esculturas com materiais reciclados"
    ]
  },
  spaces: {
    title: "Espaços de Aprendizagem",
    intro: "Criaremos diferentes cantos de atividades no espaço do escritório:",
    list: [
      {
        title: "CANTO DE LEITURA",
        description: "Um espaço aconchegante com tapete, almofadas e uma estante com histórias."
      },
      {
        title: "ÁREA DE RELAXAMENTO",
        description: "Um tipi, tapete, bichos de pelúcia, colchão e tecidos. Os espaços 1 e 2 ficarão juntos."
      },
      {
        title: "JOGO SIMBÓLICO",
        description: "Cozinha, mesa, pratos e adereços para brincadeiras imaginativas."
      },
      {
        title: "CONSTRUÇÃO E MINI-MUNDOS",
        description: "Todos os materiais de construção (magnéticos, peças de madeira...), recipientes com peças soltas."
      },
      {
        title: "CANTO ARTÍSTICO",
        description: "Uma pequena mesa de Educação Infantil e uma pequena prateleira com materiais de arte."
      }
    ]
  },
  schedule: {
    title: "Programação Diária",
    list: [
      "Chegada e brincadeira livre",
      "Assembleia e introdução ao dia",
      "Oficina",
      "Lanche",
      "Brincadeira livre",
      "Oficina",
      "Assembleia final e relaxamento"
    ]
  },
  prices: {
    title: "Preços",
    headers: {
      fullCamp: "4 Dias",
      singleDay: "Dia Avulso",
      earlyBird: "Entrada Antecipada",
      lunch: "Almoço"
    },
    students: "Alunos Gándara",
    external: "Alunos Externos"
  },
  contact: {
    title: "Contate-nos",
    button: "Agendar uma Visita"
  }
};

export const christmasCamp = {
  title: "Acampamento de Natal",
  subtitle: "Um acampamento onde a brincadeira livre, a curiosidade e a criatividade guiam cada dia, com acompanhamento próximo e respeitoso",
  gallery: {
    title: "Galeria",
    caption: "Momentos mágicos do nosso acampamento de Natal",
    images: [
      { src: "/lovable-uploads/christmas-camp-poster.jpg", alt: "Cartaz do Acampamento de Natal" }
    ]
  },
  description: {
    title: "Visão Geral do Acampamento",
    content1: "Celebre as festas conosco em um ambiente mágico onde as crianças poderão desfrutar de atividades criativas, oficinas de Natal e momentos de brincadeira livre.",
    content2: "Nossa equipe de acompanhantes cria um espaço seguro e respeitoso onde cada criança pode explorar, criar e se divertir no seu próprio ritmo."
  },
  activities: {
    title: "Atividades",
    list: [
      "Oficinas criativas de Natal",
      "Culinária saudável e receitas da época",
      "Oficinas de arte e expressão sensorial",
      "Brincadeira livre e exploração",
      "Atividades ao ar livre",
      "Contação de histórias e música"
    ]
  },
  schedule: {
    title: "Datas e Horários",
    dates: "22 de dezembro de 2026 a 7 de janeiro de 2027",
    note: "(exceto feriados)",
    hours: "Horário: 9:00 - 14:00",
    extended: "Estendido: 8:30 - 15:30",
    ages: "Idades: 3 a 12 anos"
  },
  prices: {
    title: "Preços",
    members: "Membros Gándara",
    nonMembers: "Não membros",
    oneWeek: "1 Semana",
    complete: "Completo"
  },
  contact: {
    title: "Reserve sua vaga!",
    button: "Inscrever-se"
  }
};

export const summerCamp = {
  title: "Acampamento de Verão 2026",
  subtitle: "Junte-se a uma experiência inesquecível no acampamento de verão da Gándara International School",
  gallery: {
    title: "Galeria",
    caption: "Momentos dos nossos acampamentos de verão",
    images: [
      { src: "/lovable-uploads/86807e57-9b48-4117-811e-2178c1e55e7d.png", alt: "Crianças brincando ao ar livre" },
      { src: "/lovable-uploads/4fb227e3-a5f5-4a84-94b3-bdbd9ebd058b.png", alt: "Explorando a natureza" },
      { src: "/lovable-uploads/b8f5b9b1-cac2-4895-b283-d2a0df3dbed9.png", alt: "Atividades criativas" }
    ]
  },
  intro: "Este verão, na Gándara International School, abrimos as portas para uma experiência inesquecível: um acampamento único onde a natureza, a brincadeira e o desenvolvimento emocional se entrelaçam para oferecer a cada criança um verão repleto de magia, descoberta e crescimento pessoal.",
  educationalProposal: {
    title: "Uma proposta educativa diferente",
    content: "Na Gándara International School, acreditamos que um futuro brilhante começa com uma infância vivida em plenitude. Nosso acampamento não é apenas um espaço de lazer, mas uma experiência educativa integral, em um ambiente onde as crianças podem:",
    items: [
      "Reconectar-se com a natureza e com seu próprio ritmo interior.",
      "Descobrir o mundo através da brincadeira, da emoção e da curiosidade.",
      "Sentir-se ouvidas, acompanhadas e respeitadas."
    ],
    additional: "Cada dia é uma oportunidade para crescer, imaginar, explorar, aprender e compartilhar. Este acampamento nasce do compromisso pedagógico da Gándara International School, integrando metodologias como:",
    methodologies: [
      "Educação na natureza (escola de floresta e aprendizado do inglês)",
      "Propostas STEM para despertar o pensamento lógico e científico",
      "Atividades de leitura, histórias e escrita criativa para nutrir a linguagem, a expressão e a imaginação"
    ],
    conclusion: "Uma combinação que impulsiona tanto o aprendizado ativo quanto o desenvolvimento emocional e social.",
    workshopsTitle: "Oficinas temáticas semanais",
    workshops: [
      { day: "Segunda-feira", activity: "Arte" },
      { day: "Terça-feira", activity: "Trabalhos manuais" },
      { day: "Quarta-feira", activity: "Culinária" },
      { day: "Quinta-feira", activity: "Experiências e propostas das crianças" },
      { day: "Sexta-feira", activity: "Saídas" }
    ],
    workshopsNote: "As oficinas não são obrigatórias e podem ser modificadas em função dos participantes."
  },
  principles: {
    title: "Nossos princípios pedagógicos",
    list: [
      "Conexão com a natureza a partir da experiência direta",
      "Brincadeira livre como base para a aprendizagem",
      "Acompanhamento individualizado e respeitoso",
      "Dinâmicas que fomentam empatia, cooperação e autorregulação",
      "Atividades significativas para desenvolver a inteligência prática e emocional",
      "Espaços para crescer com confiança, autonomia e alegria",
      "Fomentar a curiosidade científica e o pensamento lógico através de propostas STEM adaptadas a cada etapa"
    ]
  },
  audience: {
    title: "A quem se destina?",
    ageGroups: "Meninos e meninas de 3 a 12 anos",
    ratio: "Proporção 1:14",
    note: "Trabalhamos com grupos reduzidos, garantindo uma atenção personalizada e um acompanhamento próximo."
  },
  location: {
    title: "Localização privilegiada",
    name: "Gándara International School",
    address: "Gondomar (Pontevedra)",
    description: "Um entorno rural natural, seguro e cheio de possibilidades:",
    features: [
      "Amplos jardins exteriores com piscina",
      "Salas polivalentes para oficinas e atividades tranquilas",
      "Cozinha, banheiros e áreas cobertas adaptadas à infância e à climatologia",
      "Horta escolar ativa durante todo o verão"
    ]
  },
  schedule: {
    title: "Datas e horários",
    dates: "De 22 de junho a 4 de setembro de 2026",
    days: "De segunda a sexta-feira, em horário matutino",
    holidays: "Feriados: 24 de junho (feriado regional) e 17 de agosto (feriado local)",
    timetable: {
      title: "Horário típico:",
      slots: [
        { time: "09:00 - 10:00", activity: "Chegada flexível" },
        { time: "10:00 - 10:30", activity: "Círculo da manhã: apresentação da oficina do dia e tempo para partilhar" },
        { time: "10:30 - 11:30", activity: "Oficina temática do dia" },
        { time: "11:30 - 12:00", activity: "Lanche" },
        { time: "12:00 - 13:30", activity: "Brincadeira livre, incluindo piscina" },
        { time: "13:30 - 14:00", activity: "Arrumação de material e despedida" },
        { time: "14:00 - 15:30", activity: "Almoço (lancheira de casa)" }
      ]
    }
  },
  included: {
    title: "O que inclui o acampamento?",
    items: [
      "Oficinas temáticas diárias (arte, trabalhos manuais, culinária, experiências, saídas)",
      "Brincadeira livre e tempo de piscina",
      "Materiais didáticos e criativos",
      "Acompanhamento respeitoso por profissionais qualificados",
      "Seguro de responsabilidade civil e acidentes",
      "Possibilidade de serviço de almoço (com lancheira de casa)",
      "Possibilidade de concilia: aula madrugada e aula saída"
    ]
  },
  toBring: {
    title: "O que as crianças devem trazer?",
    items: [
      "Roupa confortável que possa se sujar",
      "Mochila com garrafa de água e lanche",
      "Boné e proteção solar",
      "Toalha e fato de banho (para a piscina)",
      "Muda de roupa",
      "Capa de chuva (em caso de chuva)"
    ],
    note: "Tudo marcado com seu nome para evitar perdas."
  },
  registration: {
    cta: "Inscreva-se agora",
    title: "Inscrição",
    limitedSpots: "Vagas limitadas!",
    options: "Você pode se inscrever por semanas ou por todo o verão.",
    form: {
      title: "Formulário de inscrição",
      parentInfo: "Informações do pai/mãe/responsável",
      childInfo: "Informações da criança",
      weeksSelection: "Seleção de semanas",
      options: "Opções adicionais",
      membership: "Associação à Gándara",
      submit: "Enviar inscrição"
    }
  },
  pricing: {
    title: "Preços",
    weeks: {
      oneWeek: "1 Semana",
      twoWeeks: "2 Semanas",
      threeWeeks: "3 Semanas",
      fourWeeks: "4 Semanas",
      fiveWeeks: "5 Semanas"
    },
    members: "Membros da Gándara",
    nonMembers: "Não membros",
    options: {
      lunch: "Almoço (lancheira de casa)",
      earlyDropoff: "Aula madrugada",
      latePickup: "Aula saída"
    },
    labels: {
      daily: "Diário",
      weekly: "Semanal",
      monthly: "Mensal",
      perSection: "Por tramo"
    },
    discounts: {
      title: "Descontos para irmãos",
      secondChild: "10% de desconto para o 2º filho/a",
      thirdChild: "25% de desconto para o 3º filho/a e seguintes"
    }
  },
  faq: {
    title: "Perguntas frequentes",
    questions: [
      {
        question: "Quais idades podem participar do acampamento?",
        answer: "Podem participar crianças de 3 a 12 anos, com uma proporção de 1:14."
      },
      {
        question: "O que acontece se meu filho tem restrições alimentares?",
        answer: "Por favor, indique qualquer alergia ou restrição alimentar no formulário de inscrição, e nos adaptaremos adequadamente."
      },
      {
        question: "Qual é a política de cancelamento?",
        answer: "Cancelamentos realizados até duas semanas antes da data de início recebem reembolso completo. Cancelamentos dentro das duas semanas prévias à data de início recebem reembolso de 50%. Não há reembolsos para cancelamentos dentro das 72 horas prévias à data de início."
      },
      {
        question: "As oficinas são obrigatórias?",
        answer: "Não, as oficinas não são obrigatórias. As crianças podem participar livremente e as atividades podem ser modificadas em função dos participantes."
      }
    ]
  }
};

export const summerCampConfirmation = {
  title: "Inscrição Enviada!",
  subtitle: "Recebemos a sua inscrição para o acampamento de verão. Receberá um email de confirmação em breve.",
  contactTitle: "Precisa de nos contactar?",
  contact: {
    phone: "Telefone",
    email: "Email",
  },
  backToCamp: "Voltar ao acampamento",
  backToHome: "Voltar ao início",
  note: "Se não receber o email de confirmação, verifique a sua pasta de spam ou contacte-nos diretamente.",
};
